import React, { Component } from 'react'
import { DragSource } from 'react-dnd-old'
import ItemTypes from './ItemTypes'
import DraggingInfo from './DraggingInfo'
import { getEmptyImage } from 'react-dnd-html5-backend-old'
import renderCompImg from '../../source/Comp_Img'

const cardSource = {
    beginDrag(props) {
        sessionStorage.setItem('dragingItem', props.type)
        DraggingInfo.isDragging = true
        // Poki: if this component needs + / - but no free power pin exists, the
        // drop will be rejected — warn now, at drag-start (no highlight shows).
        if (window.appState && window.appState.warnIfPowerBlocked)
            window.appState.warnIfPowerBlocked(props.type, null)
        return { type: props.type }
    },
    endDrag: (props) => {
        DraggingInfo.isDragging = false
        DraggingInfo.newComponentPort = null
        sessionStorage.setItem('dragingItem', null)

        if (
            [
                'play_shield',
                'play_shield_v1',
                'arm_shield',
                'peeCee_ATR',
            ].includes(props.type)
        ) {
            window.location.reload()
        }
    },
}

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    }
}

class Card extends Component {
    constructor(props) {
        super(props)

        this.state = {}

        this.isComImgev1 =
            ['1', '2', '3'].includes(
                sessionStorage.getItem('deviceVersion')[0]
            ) ||
            ['Roboki', 'Atr', 'Toki', 'Poki', 'Moki', 'woofKit'].includes(
                sessionStorage.getItem('connectedDevice')
            )
    }
    componentDidMount() {
        // Use empty image as a drag preview so browsers don't draw it
        this.props.connectDragPreview(getEmptyImage(), {
            captureDraggingState: true,
        })
    }

    render() {
        const { connectDragSource, type } = this.props

        const isPlayShield = sessionStorage.getItem('shield') === 'true'
        const isArmShield = sessionStorage.getItem('armShield') === 'true'
        const isPeeCeeATR = sessionStorage.getItem('peeCeeATR') === 'true'

        const isShieldComponent = [
            'play_shield',
            'arm_shield',
            'peeCee_ATR',
            'play_shield_v1',
        ].includes(type)
        const hasActiveShield = isPlayShield || isArmShield || isPeeCeeATR

        // ONE UNIVERSAL STYLE FOR ALL COMPONENTS
        const imageStyle = {
            zIndex: '50',
            width: 'auto', // Standard width
            maxWidth: 'auto', // Prevents giant images
            height: '100px',
            maxHeight: '100px',
            objectFit: 'contain', // Keeps aspect ratio without stretching
            display: 'block',
            margin: '10px auto', // Automatically centers the image
            opacity: isShieldComponent && hasActiveShield ? 0.5 : 1,
            cursor:
                isShieldComponent && hasActiveShield ? 'default' : 'pointer',
        }

        const imageElement = (
            <img style={imageStyle} src={renderCompImg(type)} alt={type} />
        )

        // If it's a shield and a shield is already active, return non-draggable version
        if (isShieldComponent && hasActiveShield) {
            return imageElement
        }

        // Return standard draggable component
        return connectDragSource(imageElement)
    }
}

export default DragSource(ItemTypes.COMPONENT, cardSource, collect)(Card)
